// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/create_app'

Styxie.Initializers.MobileEmployees = {
  // Phase 1: Employees Index
  // index: async(props) => { ... }

  // Phase 1: Employee Create/Edit
  // new: async(props) => { ... }
  // edit: async(props) => { ... }
}
